export class FetchError extends Error {
  constructor(message: string, public metadata: Record<string, any>) {
    super(message)
  }
}
